import { HiveReference, ReferencePopup } from './reference-node';

export function effects() {
  customElements.define('reference-popup', ReferencePopup);
  customElements.define('hive-reference', HiveReference);
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-reference': HiveReference;
    'reference-popup': ReferencePopup;
  }
}
